// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"740":"919be0aa","847":"fcaf8859"}[chunkId] + ".css";
};